<template>
  <div>
    <div v-if="!party">
      {{ $t("Loading") }}<br>
      <img alt="Seite wird geladen, bitte warten" src="../assets/spinner.gif">
    </div>
    <div v-if="party">
      <div v-if="entryType === 'shortshort'">
        <TheShortShortEntry />
      </div>

      <div v-if="entryType === 'short'">
        <TheShortEntry />
      </div>

      <div v-if="entryType === 'full'">
        <TheFullEntry />
      </div>
    </div>

    <!-- Only for dev, debugging; remove later -->
    <div
      v-if="
        (entryType !== 'short') &
        (entryType !== 'shortshort') &
        (entryType !== 'full') &
        (entryType !== 'none')
      "
    >
      <div v-if="party">
          <h1 class="mb-5">{{ $t("Error.SomethingWentWrong") }}</h1>
          <button class="text-white text-base px-3 py-1 rounded bg-red-600 cursor-pointer text-l underline bold mt-3 inline-block">
            <a href="/" style="color: #fff">{{ $t("goToHomepage") }}</a>
          </button>
      </div>      
    </div>
  </div>
</template>

<script>
import { companyNameResort } from "../utils/CompanyNameResorter";
import { EntryTypesEnum } from "../enums";
import { usePartyStore } from "../stores/PartyStore";
import TheShortShortEntry from "./entries/TheShortShortEntry.vue";
import TheShortEntry from "./entries/TheShortEntry.vue";
import TheFullEntry from "./entries/TheFullEntry.vue";

export default {
  async created() {
    this.partyStore = usePartyStore();
    // search with ID
    if(this.$route.params.id) {
      await this.partyStore.searchParty(this.$route.params.id);
    }
    // Search with MVB-ID
    if(this.$route.params.mvbid) {
      await this.partyStore.searchMvbId(this.$route.params.mvbid);
    }    
    //If fetch not finished jet...
    if (!this.party) {
      return;
    } //... will be called later again in beforeUpdate()
    this.buildUrl();
    this.entryType = this.computeEntryType();
  },

  async beforeUpdate() {
    // search with ID
    if(this.$route.params.id) {
      await this.partyStore.searchParty(this.$route.params.id);
    }
    // Search with MVB-ID
    if(this.$route.params.mvbid) {
      await this.partyStore.searchMvbId(this.$route.params.mvbid);
    }   

    //If fetch not finished jet...
    if (!this.party) {
      return;
    } //... will be called later again
    this.entryType = this.computeEntryType();
    this.buildUrl();
  },

  data() {
    return {
      partyStore: null,
      entryType: null,
    };
  },

  computed: {
    //Shortcut: You can write this.party instead of this.partyStore.party
    party() {
      return this.partyStore.party;
    },
  },

  methods: {
    computeEntryType() {
    // null check, otherwise internal links do not work
    if(this.party) {

        //Short entry
        if (
          (this.party.lockKey && //lockKey exists
          this.party.lockKey.split(' ').includes('11') && //lockKey 11
          this.party.archiveDateAdb == null && //not archived
          this.party.isbns &&
          this.party.isbns.length > 0 && //has at least 1 ISBN
          this.party.postalAddress.country && //Has adress with country
          this.party.postalAddress.country == "DE")
          || !(this.party.postalAddress && this.party.postalAddress.country) // No country in the data -> Short entry
        ) {
          //Country is Germany
          //return EntryTypesEnum.SHORT;
          return EntryTypesEnum.SHORTSHORT; //business reasons
        }

        //Shortshort entry
        if (
          this.party.archiveDateAdb && //is archived
          this.party.isbns && 
          this.party.isbns.length > 0
        ) {
          return EntryTypesEnum.SHORTSHORT;
        }

        

        //More to come later with other tickets
        return EntryTypesEnum.FULL;
      }
    },

    buildUrl() {
      let url = '/party';
      // null check, otherwise internal links do not work
      if(this.party) {

      let businessType = this.$t('Party.BusinessType.' + this.party.businessType)
      url += '/' + businessType;

      let companyName = this.party.companyName;
      let companyNameAddendum = this.party.companyNameAddendum;

      // Ticket #32923 says if the parent store exists, always city and street should be added,
      // and if in this the city is double, it should be removed from the first, either companyName or companyNameAddendum.
      let postalAddressCity = null;
      let postalAddressStreet = null;
      if (this.party.parentStore) {
        postalAddressCity = this.party.postalAddress.cityStreet;
        //Sic! Check if special characters in city not in ticket.

        postalAddressStreet = this.party.postalAddress.street1;
        postalAddressStreet = this.urlSpeacialCharReplace(postalAddressStreet);

        //if cmopanyName contains postalAddressCity
        if (companyName && companyName.search(postalAddressCity >= 0)) {
          companyName = companyName.replace(postalAddressCity, '');
        }
        else {
          companyNameAddendum = companyNameAddendum.replace(postalAddressCity, '');
        }
      }

      // Ticket #35742 is a little strange at it's end...
      if (this.party.businessType == 1) {
        const toRemove = ', Verlag';
        if (companyName && toRemove == companyName.substring(companyName.length - toRemove.length)) {
          companyName = companyName.substring(0, companyName.length - toRemove.length);
        }
        if (companyNameAddendum && toRemove == companyNameAddendum.substring(companyNameAddendum.length - toRemove.length)) {
          companyName = companyNameAddendum.substring(0, companyNameAddendum.length - toRemove.length);
        }
      }

      companyName = companyName ? companyNameResort(companyName) : null;
      companyName = companyName ? this.urlSpeacialCharReplace(companyName) : null;

      if (companyName && companyName != null && companyName.length > 0) {
        url += '/' + companyName;
      }

      if (this.isZWE()) {
        url += '/' + this.$t('URL.ZWE');
        url += '/' + this.getCityZWE();
        url += '/' + this.$route.params.id;
        this.$router.replace(url);
        return;
      }

      companyNameAddendum = this.urlSpeacialCharReplace(companyNameAddendum);
      if (companyName && companyNameAddendum != null && companyNameAddendum.length > 0) {
        url += '/' + companyNameAddendum;
      }

      if (this.party.parentStore) {
        //Sic! No null check for these 2 fields in ticket.
        url += '/' + postalAddressCity;
        url += '/' + postalAddressStreet;
      }

      if (this.entryType == EntryTypesEnum.FULL) {
        url += '/premium';
      }

      url += '/' + this.$route.params.id;
      this.$router.replace(url);
      }
    },

    urlSpeacialCharReplace(string){
      if (string == undefined) {
        return string;
      }

      string = string.replaceAll(' ', '-');
      string = string.replaceAll('Ä', 'Ae');
      string = string.replaceAll('Ö', 'Oe');
      string = string.replaceAll('Ü', 'Ue');
      string = string.replaceAll('ä', 'ae');
      string = string.replaceAll('ö', 'oe');
      string = string.replaceAll('ü', 'ue');
      string = string.replaceAll('ß', 'ss');

      string = string.replaceAll(',', '');
      string = string.replaceAll('(', '');
      string = string.replaceAll(')', '');
      string = string.replaceAll('.', '');

      string = string.replaceAll('c/o', 'bei');
      string = string.replaceAll('&', 'und');

      string = string.replaceAll('Dr.', 'Dr');
      string = string.replaceAll('Prof.', 'Prof');
      string = string.replaceAll('e.V.', 'eV');

      string = string.replaceAll('/', '');
      string = string.replaceAll('---', '-');
      string = string.replaceAll('-+', '+');
      string = string.replaceAll('+-', '+');
      string = string.replaceAll('--', '-');

      // – long minus
      string = string.replaceAll('–-', '–');
      string = string.replaceAll('-–', '–')

      return string;
    },

    isZWE() {
      return (this.party.companyNameAddendum && (this.party.companyNameAddendum.includes(', ZWE') || this.party.companyNameAddendum.includes('ZWE, ')))
        || (this.party.vnrZusatzDebitor && (this.party.vnrZusatzDebitor.includes(', ZWE') || this.party.vnrZusatzDebitor.includes('ZWE, ')))
        || (this.party.shortNameVLB && (this.party.shortNameVLB.includes(', ZWE') || this.party.shortNameVLB.includes('ZWE, ')));
    },

    getCityZWE() {
      let toParse = this.party.vnrZusatzDebitor ? this.party.vnrZusatzDebitor : this.party.shortNameVLB;

      let split = toParse.split(',');
      split = split.map(a => a.trim());

      let index = 'ZWE' == split[0] ? 1 : 0; //Use the other, where not ZWE
      split = split[index].split(' ');

      /* Most time it's 3 and the city is in the middle - but the city might be longe. -> Remove 1st ("Thalia") and last party
       * (last will be a 4-digit number), the rest seems to be the city in most cases
       */
      let result = '';
      for (let i = 1; i < split.length - 1; i++) {
        if (split[i] == 'Mayersche') {
          continue;
        }
        if (result.length > 0) {
          result += ' ';
        }
        result += split[i];
      }
      
      return this.urlSpeacialCharReplace(result);
    },
  },

  components: { TheShortEntry, TheShortShortEntry, TheFullEntry },
};
</script>
